import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';

const SubtitleTimeField = ({ value, onKeyDown, field, index, updateSub, rowData, disabled }) => {
    return (
        <TimeField
            id={`subTitleTimer${field}Input${index}`}
            value={dayjs('2022-04-17T' + value)}
            format="HH:mm:ss"
            disabled={disabled}
            border="none"
            onChange={(newValue) => {
                if (newValue && newValue.isValid()) {
                    const dateObj = new Date(newValue);
                    const timeString = dateObj.toLocaleTimeString([], { hour12: false });
                    updateSub(rowData, { [field]: timeString });
                }
            }}
            slotProps={{
                textField: {
                    size: 'small',
                    sx: {
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: 'none',
                            },
                            '&:hover fieldset': {
                                border: 'none',
                            },
                            '&.Mui-focused fieldset': {
                                border: 'none',
                            },
                        },
                    },
                },
                digitalClockItem: {
                    sx: { width: '100%' },
                },
            }}
        />
    );
};

export default SubtitleTimeField;
